import React from 'react';
import { CopyrightImage } from './styles';
import copyrightImg from '../../assets/images/copyright-image.svg';

const Copyright = () => {
  return (
    <CopyrightImage src={copyrightImg} width={128} alt="Copyright Excel Credit" id="copyright" />
  )
}

export default Copyright
